__turbopack_context__.v({
  "casePrice": "cartItems-module-scss-module__sQ3Uiq__casePrice",
  "caseSuffix": "cartItems-module-scss-module__sQ3Uiq__caseSuffix",
  "discountPrice": "cartItems-module-scss-module__sQ3Uiq__discountPrice",
  "discountSubtotalPrice": "cartItems-module-scss-module__sQ3Uiq__discountSubtotalPrice",
  "keyclubPrice": "cartItems-module-scss-module__sQ3Uiq__keyclubPrice",
  "productImage": "cartItems-module-scss-module__sQ3Uiq__productImage",
  "productName": "cartItems-module-scss-module__sQ3Uiq__productName",
  "productPrice": "cartItems-module-scss-module__sQ3Uiq__productPrice",
  "productQuantity": "cartItems-module-scss-module__sQ3Uiq__productQuantity",
  "productRemove": "cartItems-module-scss-module__sQ3Uiq__productRemove",
  "productSubtotal": "cartItems-module-scss-module__sQ3Uiq__productSubtotal",
  "promoPrice": "cartItems-module-scss-module__sQ3Uiq__promoPrice",
  "rowRemoving": "cartItems-module-scss-module__sQ3Uiq__rowRemoving",
  "toasts": "cartItems-module-scss-module__sQ3Uiq__toasts",
  "wrapper": "cartItems-module-scss-module__sQ3Uiq__wrapper",
});
